import { SYMPTOMS_ENDPOINT } from "../../endpoints";
import { fetcher } from "../../utils";
import { convertSymptomsFromAPI, invertSymptomsData } from "./converters";
import { Symptoms } from "./types";

export const getSymptoms = async ({ testId }: { testId: string }) => {
    const response = await fetcher(SYMPTOMS_ENDPOINT, {
        params: { test_id: testId },
    });

    return convertSymptomsFromAPI(response);
};

export const submitSymptoms = async ({
    testId,
    values,
}: {
    testId: string;
    values: Symptoms;
}) => {
    const response = await fetcher(
        SYMPTOMS_ENDPOINT,
        {
            method: "PUT",
            params: { test_id: testId },
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(invertSymptomsData(values)),
        },
        true
    );

    return convertSymptomsFromAPI(response);
};
